import { capitalize } from 'lodash'
import Styles from './PlanFeatureRow.module.scss'

export interface PlanFeatureRowProps {
  limit?: number | string
  feature: string
  icon: React.ReactNode
}

export const PlanFeatureRow = ({ icon, limit, feature }: PlanFeatureRowProps) => {
  return (
    <div className={Styles.rowContainer}>
      <div className={Styles.rowIconContainer}>{icon}</div>{' '}
      <span>
        {!!limit && <span className={Styles.rowIconBold}>{typeof limit === 'number' ? limit : capitalize(limit)}</span>}{' '}
        {feature}
      </span>
    </div>
  )
}
